import { initReactI18next } from 'react-i18next'
import { i18nLocEn } from 'i18n/languages/en'
import { i18nLocRu } from 'i18n/languages/ru'
import i18next, { Resource } from 'i18next'
import Cookies from 'js-cookie'
import CookiesKeys from 'data/cookiesKeys'

const resources: Resource = {
  ru: i18nLocRu,
  en: i18nLocEn,
}

export const languages: { id: string, title: string, icon: string, dateFnsLocale: Locale }[] = Object
  .keys(resources)
  .map((language, index) => ({
    id: language,
    title: Object.values(resources)[index].__title as string,
    icon: Object.values(resources)[index].__icon as string,
    dateFnsLocale: Object.values(resources)[index].__dateFnsLocale as Locale,
  }))

i18next
  .use(initReactI18next)
  .init({
    resources,
    lng: Cookies.get(CookiesKeys.language) ?? 'ru',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18next
